module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.curInput.file,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "模板类型",
      "prop": "templet"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.file.templet),
      expression: "curInput.file.templet"
    }],
    staticClass: "h-40 w-200",
    attrs: {
      "placeholder": "请选择模板类型"
    },
    domProps: {
      "value": (_vm.curInput.file.templet)
    },
    on: {
      "input": function($event) {
        _vm.curInput.file.templet = $event
      }
    }
  }, _vm._l((_vm.uploadType), function(item, index) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上传文件夹名",
      "prop": "dir_name"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.curInput.file.dir_name),
      expression: "curInput.file.dir_name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-200",
    attrs: {
      "placeholder": "请填写上传文件夹名"
    },
    domProps: {
      "value": (_vm.curInput.file.dir_name)
    },
    on: {
      "input": function($event) {
        _vm.curInput.file.dir_name = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "文件大小",
      "prop": "file_max"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.curInput.file.file_max),
      expression: "curInput.file.file_max",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-100",
    domProps: {
      "value": (_vm.curInput.file.file_max)
    },
    on: {
      "input": function($event) {
        _vm.curInput.file.file_max = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.file.file_unit),
      expression: "curInput.file.file_unit"
    }],
    staticClass: "h-40 w-100",
    attrs: {
      "placeholder": "请选择文件大小单位"
    },
    domProps: {
      "value": (_vm.curInput.file.file_unit)
    },
    on: {
      "input": function($event) {
        _vm.curInput.file.file_unit = $event
      }
    }
  }, _vm._l((_vm.fileUnit), function(item, index) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "文件类型(不选默认不限制)",
      "prop": "file_type"
    }
  }, [_c('el-checkbox', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.file.checkAllFile),
      expression: "curInput.file.checkAllFile"
    }],
    domProps: {
      "value": (_vm.curInput.file.checkAllFile)
    },
    on: {
      "change": function($event) {
        _vm.checkAllChange(_vm.curInput.file)
      },
      "input": function($event) {
        _vm.curInput.file.checkAllFile = $event
      }
    }
  }, [_vm._v("全选")]), _vm._v(" "), _c('el-checkbox-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.file.file_type),
      expression: "curInput.file.file_type"
    }],
    domProps: {
      "value": (_vm.curInput.file.file_type)
    },
    on: {
      "input": function($event) {
        _vm.curInput.file.file_type = $event
      }
    }
  }, _vm._l((_vm.fileType), function(item, index) {
    return _c('el-checkbox', {
      attrs: {
        "label": item.id
      },
      on: {
        "change": function($event) {
          _vm.isCheckAll(_vm.curInput.file)
        }
      }
    }, [_vm._v(_vm._s(item.name) + _vm._s(item.explain))])
  }))]), _vm._v(" ")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-01e19608!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Model/configComponents/fileConfig.vue
// module id = 1755
// module chunks = 2